// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__Y8a55"};